/**
 * Enhancer — Twitch / Kick enhancement suite
 *
 * Its single web-accessible-resource entry — index.js, the *.constants.js files and
 * assets globs — is matched only to twitch.tv and kick.com. Nothing scopes it to an
 * arbitrary page, so those resources are genuinely unreachable elsewhere and a negative
 * from any other origin says nothing.
 *
 * From Twitch, though, the resources are static (no use_dynamic_url) and served at a
 * fixed URL, so a fetch of the vendor-named twitch.constants.js is conclusive.
 *
 * Manifest verified against version 5.1.39.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'knaodoefkjbgmmilogebghadhmnphjih';

export const enhancer: ExtensionDefinition = {
  id: ID,
  name: 'Enhancer',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  requiredOrigin: 'https://www.twitch.tv',
  notes:
    'WAR scoped to twitch.tv and kick.com, so only those sites can detect it. The ' +
    'resources are static, so from Twitch a single fetch is conclusive.',
  signals: [
    {
      id: 'war-twitch-constants-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch twitch.constants.js — a vendor-named script, static and scoped to Twitch/Kick.',
      weight: 1,
      run: () => probeFetch(ID, 'twitch.constants.js'),
    },
    {
      id: 'war-index-js',
      kind: 'web-accessible-resource',
      description: 'Fetch index.js — the main injected bundle, a second scoped path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'index.js'),
    },
    {
      id: 'war-enhancer-logo-svg',
      kind: 'web-accessible-resource',
      description: 'Fetch assets/enhancer/logo.svg — the vendor logo, a third scoped path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'assets/enhancer/logo.svg'),
    },
  ],
};
